import React from 'react';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import ContactForm from 'components/ContactForm/ContactForm';
import Card from 'components/Card/Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Helmet } from 'react-helmet-async';
import { faPhone, faEnvelope, faMapMarkerAlt, faClock } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faTiktok } from '@fortawesome/free-brands-svg-icons';
import './ContactPage.css';
import { serviceCounties } from 'data';

const ContactPage: React.FC = () => {

	// Same obfuscation pattern used in ContactForm.tsx to prevent bot scraping
	// const getPhone = () => atob('KDIwOCkgNDE5LTkyMzU=');
	// const getPhoneLink = () => atob('dGVsOisxMjA4NDE5OTIzNQ==');
	// const getEmail = () => atob('dGhlZ29hdGdyYXplcnMudG5AZ21haWwuY29t');
	// const getMailLink = () => atob('bWFpbHRvOnRoZWdvYXRncmF6ZXJzLnRuQGdtYWlsLmNvbQ');

	return (
		<div className="contact-page">
			<Helmet>
				<title>Contact Us | The G.O.A.T. Grazers</title>
				<meta name="description" content="Get in touch with The G.O.A.T. Grazers to schedule a free site evaluation and estimate for your land clearing needs." />
			</Helmet>
			<div className="container">
				<SectionHeader
					title="Get In Touch"
					subtitle="Ready to let our herd loose on your overgrowth? Request a free, no-obligation estimate."
					as="h1"
				/>

				<div className="contact-page__layout">
					{/* Left column — contact info */}
					<aside className="contact-page__sidebar">
						<Card variant="green-outlined" hoverable={false} className="contact-page__info-card">
							<div className="contact-page__info-item">
								<span className="contact-page__info-icon">
									<FontAwesomeIcon icon={faMapMarkerAlt} />
								</span>
								<div>
									<h4>Location</h4>
									<p>We proudly serve these east Tennessee counties:</p>
									<p className="contact-page__info-sub">
										Anderson, Blount, Jefferson, Knox, Loudon, Monroe, Roane, Sevier
									</p>
								</div>
							</div>

							{/* <div className="contact-page__info-item">
								<span className="contact-page__info-icon">
									<FontAwesomeIcon icon={faPhone} />
								</span>
								<div>
									<h4>Call or Text</h4>
									<p>
										<a href={getPhoneLink()}>{getPhone()}</a>
									</p>
								</div>
							</div>

							<div className="contact-page__info-item">
								<span className="contact-page__info-icon">
									<FontAwesomeIcon icon={faEnvelope} />
								</span>
								<div>
									<h4>Email</h4>
									<p>
										<a href={getMailLink()}>{getEmail()}</a>
									</p>
								</div>
							</div> */}

							<div className="contact-page__info-item">
								<span className="contact-page__info-icon">
									<FontAwesomeIcon icon={faClock} />
								</span>
								<div>
									<h4>Response Time</h4>
									<p>We typically respond within 2 business days.</p>
								</div>
							</div>
						</Card>

						<Card variant="green-outlined" hoverable={false} className="contact-page__socials">
							<h4 className="contact-page__socials-title">Follow the Herd</h4>
							<div className="contact-page__socials-links">
								<a href="https://www.facebook.com/share/16kRw8soJC" target="_blank" rel="noreferrer" className="contact-page__social-link" aria-label="Facebook">
									<FontAwesomeIcon icon={faFacebook} />
								</a>
								<a href="https://www.instagram.com/the_goat_grazers" target="_blank" rel="noreferrer" className="contact-page__social-link" aria-label="Instagram">
									<FontAwesomeIcon icon={faInstagram} />
								</a>
								<a href="https://www.tiktok.com/@thegoatgrazers?_r=1&_t=ZP-92kXFwS8NkV" target="_blank" rel="noreferrer" className="contact-page__social-link" aria-label="TikTok">
									<FontAwesomeIcon icon={faTiktok} />
								</a>
							</div>
						</Card>
					</aside>

					{/* Right column — the form */}
					<div className="contact-page__form-wrapper">
						<ContactForm />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ContactPage;

